__turbopack_context__.v({
  "content": "style-module-scss-module__nNw7vW__content",
  "event": "style-module-scss-module__nNw7vW__event",
  "image": "style-module-scss-module__nNw7vW__image",
  "item": "style-module-scss-module__nNw7vW__item",
  "label": "style-module-scss-module__nNw7vW__label",
  "media": "style-module-scss-module__nNw7vW__media",
  "mediaRight": "style-module-scss-module__nNw7vW__mediaRight",
  "text": "style-module-scss-module__nNw7vW__text",
  "textBlog": "style-module-scss-module__nNw7vW__textBlog",
  "title": "style-module-scss-module__nNw7vW__title",
  "titleBlog": "style-module-scss-module__nNw7vW__titleBlog",
  "titleItem": "style-module-scss-module__nNw7vW__titleItem",
  "width550": "style-module-scss-module__nNw7vW__width550",
  "width600": "style-module-scss-module__nNw7vW__width600",
  "width650": "style-module-scss-module__nNw7vW__width650",
  "width700": "style-module-scss-module__nNw7vW__width700",
  "width750": "style-module-scss-module__nNw7vW__width750",
  "width800": "style-module-scss-module__nNw7vW__width800",
  "withTopLine": "style-module-scss-module__nNw7vW__withTopLine",
  "wrapper": "style-module-scss-module__nNw7vW__wrapper",
});
